import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "feedback-modal__content" }
const _hoisted_2 = {
  key: 0,
  class: "feedback-modal__header"
}
const _hoisted_3 = { class: "feedback-modal__icon" }
const _hoisted_4 = { class: "feedback-modal__header-title" }
const _hoisted_5 = { class: "feedback-modal__header-paragraphe" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 2,
  class: "feedback-modal__form"
}
const _hoisted_8 = {
  class: "feedback-modal__form-label",
  for: "subject"
}
const _hoisted_9 = { class: "feedback-modal__form-warning" }
const _hoisted_10 = { class: "feedback-modal__form-warning" }
const _hoisted_11 = {
  class: "feedback-modal__form-label",
  for: "message"
}
const _hoisted_12 = { class: "feedback-modal__form-warning" }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "feedback-modal__success" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hadrianLoader = _resolveComponent("hadrianLoader")!
  const _component_iconFeedback = _resolveComponent("iconFeedback")!
  const _component_limitedTextarea = _resolveComponent("limitedTextarea")!
  const _component_iconSuccess = _resolveComponent("iconSuccess")!
  const _component_hadrianModal = _resolveComponent("hadrianModal")!

  return (_openBlock(), _createBlock(_component_hadrianModal, {
    class: "feedback-modal",
    ref: "feedbackModal",
    rightButtonText: _ctx.confirmedbuttonText,
    rightButtonDisabled: _ctx.canSendMail,
    hideOnRightClick: _ctx.isMailSent || _ctx.isLoading,
    hideLeftButton: _ctx.isMailSent,
    hideHeader: "",
    onRightButtonClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSendMail()))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_hadrianLoader, { isLoading: _ctx.isLoading }, null, 8, ["isLoading"]),
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.isMailSent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_iconFeedback)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('feedbackModal.subtitle')), 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('feedbackModal.subtitleMessage')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isMailSent)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "feedback-modal__blue-background",
              innerHTML: _ctx.$t('feedbackModal.infoMessage')
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        (!_ctx.isMailSent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_8, [
                  _cache[3] || (_cache[3] = _createElementVNode("sup", { class: "error" }, "*", -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t('feedbackModal.subject')), 1)
                ]),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('feedbackModal.subjectWarning')), 1),
                _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                _createVNode(_component_limitedTextarea, {
                  id: "feedback-modal__subject",
                  class: "feedback-modal__form-input",
                  customClass: 'feedback-modal__subject',
                  modelValue: _ctx.subject,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.subject) = $event)),
                  maxLength: 60
                }, null, 8, ["modelValue"]),
                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('feedbackModal.subjectRules')), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_11, [
                  _cache[6] || (_cache[6] = _createElementVNode("sup", { class: "error" }, "*", -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t('feedbackModal.message')), 1)
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                _createVNode(_component_limitedTextarea, {
                  id: "feedback-modal__message",
                  class: "feedback-modal__form-input",
                  customClass: 'feedback-modal__message',
                  modelValue: _ctx.message,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.message) = $event)),
                  maxLength: 2000
                }, null, 8, ["modelValue"]),
                _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('feedbackModal.messageRules')), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, [
                  _createVNode(_component_iconSuccess),
                  _cache[9] || (_cache[9] = _createElementVNode("p", null, "Thank you for sharing with us!", -1))
                ])
              ])
            ]))
      ])
    ], undefined, true),
    _: 1
  }, 8, ["rightButtonText", "rightButtonDisabled", "hideOnRightClick", "hideLeftButton"]))
}